import { animate } from 'framer-motion';
import { ALT } from '@/store/experience';
import { audio } from '@/lib/audio';

const wait = (ms) => new Promise((r) => setTimeout(r, ms));
const tw = (obj, key, to, duration, ease = 'easeInOut') =>
  new Promise((res) => animate(obj[key], to, { duration, ease, onUpdate: (v) => { obj[key] = v; }, onComplete: res }));

// AIRPLANE → JUMP → FREEFALL → CLOUDS → FALLING COIN → CLOUDS TRANSFORM → STORYSPARK STUDIOS
export async function runCinematic(store, { reduced }) {
  const { frame, setPhase } = store.getState();
  const m = reduced ? 0.35 : 1;
  const alive = () => store.getState().phase !== 'WEBSITE';

  audio.setScene('jump', 1.5);
  await wait(2600 * m);
  if (!alive()) return;

  setPhase('FREEFALL');
  audio.setScene('freefall', 1.2);
  frame.pitch = -1.25;
  tw(frame, 'fov', 84, 3.2 * m, 'easeIn');
  await tw(frame, 'altitude', ALT.DECK_TOP, 3.3 * m, 'easeIn');
  if (!alive()) return;

  setPhase('CLOUD_TRANSITION');
  audio.setScene('clouds', 1.5);
  tw(frame, 'altitude', ALT.DECK_BOTTOM, 3.0 * m, 'linear');
  tw(frame, 'pitch', -0.15, 3.0 * m, 'easeInOut');
  (async () => {
    if (reduced) return;
    await tw(frame, 'roll', 0.42, 1.3, 'easeInOut');
    await tw(frame, 'roll', -0.2, 1.1, 'easeInOut');
    await tw(frame, 'roll', 0, 0.9, 'easeOut');
  })();
  await tw(frame, 'fog', 0.95, 1.2 * m, 'easeIn');
  await tw(frame, 'fog', 0.35, 1.6 * m, 'easeInOut');
  if (!alive()) return;

  setPhase('COIN_REVEAL');
  tw(frame, 'fog', 0, 1.8 * m, 'easeOut');
  tw(frame, 'altitude', ALT.HERO, 4.2 * m, 'easeOut');
  tw(frame, 'pitch', 0.08, 3.0 * m, 'easeInOut');
  tw(frame, 'fov', 60, 3.0 * m, 'easeInOut');
  const c = frame.coin;
  c.x = 0; c.y = 1.4; c.scale = 0.85; c.blur = 0.012;
  tw(c, 'opacity', 1, 0.9 * m, 'easeOut');
  tw(c, 'scale', 1, 2.2 * m, 'easeOut');
  await tw(c, 'y', 0.05, 2.2 * m, 'easeOut');
  tw(c, 'blur', 0.002, 1 * m);
  await wait(500 * m);
  if (!alive()) return;
  // Coin settles into the bottom-right and becomes part of the site's visual language
  tw(c, 'x', 0.68, 1.5 * m, 'easeInOut');
  tw(c, 'y', -0.5, 1.5 * m, 'easeInOut');
  tw(c, 'scale', 0.42, 1.5 * m, 'easeInOut');
  await wait(700 * m);
  if (!alive()) return;
  setPhase('WEBSITE');
  audio.setScene('website', 3);
}

export function finishCinematic(store) {
  const { frame, setPhase } = store.getState();
  frame.altitude = ALT.HERO; frame.pitch = 0.08; frame.roll = 0; frame.fov = 60; frame.fog = 0;
  Object.assign(frame.coin, { x: 0.68, y: -0.5, scale: 0.42, opacity: 1, blur: 0.002 });
  setPhase('WEBSITE');
  audio.setScene('website', 2);
}
